import script from "./WModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WModal.vue?vue&type=script&setup=true&lang=js"

import "./WModal.vue?vue&type=style&index=0&id=b057584a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b057584a"]])

export default __exports__